/* tslint:disable */
var TrackingEventShopFunnel = /** @class */ (function () {
    function TrackingEventShopFunnel(args) {
        this.EVENT_ID = 1057;
        this.data = args;
        this.data.eventId = this.EVENT_ID;
    }
    return TrackingEventShopFunnel;
}());
export { TrackingEventShopFunnel };
/* tslint:enable */



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/custom-types/TrackingEventShopFunnel.ts
// module id = 1691
// module chunks = 3